import { ANEX } from '@anex/common'
import dayjs from 'dayjs'
import { IUsageItemData, IVoIPService } from '~/types'

export const BroadbandMonthlyUsageMock: IUsageItemData = {
  year: 2025,
  month: 7,
  dailyUsage: [
    {
      day: '2025-08-01T00:00:00',
      downloadedBytes: 1319110,
      uploadedBytes: 6427390,
    },
    {
      day: '2025-08-02T00:00:00',
      downloadedBytes: 999577000,
      uploadedBytes: 474551000,
    },
    {
      day: '2025-08-03T00:00:00',
      downloadedBytes: 341112000,
      uploadedBytes: 144886000,
    },
    {
      day: '2025-08-04T00:00:00',
      downloadedBytes: 445337000,
      uploadedBytes: 149409000,
    },
    {
      day: '2025-08-05T00:00:00',
      downloadedBytes: 1551850000,
      uploadedBytes: 54432700,
    },
    {
      day: '2025-08-06T00:00:00',
      downloadedBytes: 1968850000,
      uploadedBytes: 221486000,
    },
    {
      day: '2025-08-07T00:00:00',
      downloadedBytes: 1359510000,
      uploadedBytes: 579948000,
    },
  ],
  totalDownloadedBytes: 6667555110,
  totalUploadedBytes: 1631140090,
  averageDailyDownloadedBytes: 215082422,
  averageDailyUploadedBytes: 52617422,
  daysInMonth: 31,
  monthName: 'July',
}

export const VoIPServiceMock: IVoIPService = {
  serviceNumber: '0295883283',
  domain: 'sip1.esip.com.au',
  displayCallerId: true,
  barring: {
    outgoingCalls: true,
    incomingCalls: true,
    internationalCalls: true,
    highRiskCalls: true,
    mobileCalls: true,
    callsTo: null,
    blockCallsFrom: ['0282123442'],
  },
  voicemail: {
    enableVoicemail: false,
    divertToVoicemail: 0,
    forwardVoicemailToEmail: null,
    voicemailSmsAlert: null,
  },
  forwarding: {
    forwardingNumber: '0426813746',
    divertToCallForwarding: 0,
  },
  status: {
    lastRegistrationDate: '2024-10-30 11:47:19',
    registrationStatus: 'NOT REGISTERED',
    serviceTest: 'FAILED',
  },
}

export const IsInRadiusMock: ANEX.Website.API.Endpoints.V1.Account.Services.IsInRadius_Response =
  {
    cpId: 'cpi-1234',
    providerEndpointIp: '0.0.0.0',
    framedIpAddress: '192.168.0.111',
    nasIpAddress: '192.168.0.1',
    nasPort: 1,
    upload: '600gb',
    download: '900gb',
    cir: 'cir',
    loggedInAt: dayjs().toISOString(),
    timeOnline: '18 hours',
    isConnected: true,
    anexId: 'anx-123456789',
  }

export const OutagesMock: ANEX.Website.API.Endpoints.V1.Superloop.OutageManagement.OutageManagementResponse =
  {
    data: [
      {
        id: '01k22kyvxg20y61aaq4bwyn0bh',
        provider: 'NBN',
        providerOutageId: 'CRQ000009086681',
        severity: 'Emergency',
        type: 'Scheduled Outage',
        description:
          'nbn will shortly be performing emergency work on the network to address degradation on services in your area. This work will result in a temporary service interruption. Due to local noise restrictions and safety requirements, the work will be performed during daylight hours.',
        maintenanceStartAt: '2025-08-07T14:00:00Z',
        maintenanceEndAt: '2025-08-07T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01k1tz9cvbqsztyqf2bfan2j3t',
        provider: 'NBN',
        providerOutageId: 'CRQ000009085864',
        severity: 'Emergency',
        type: 'Scheduled Outage',
        description:
          'nbn will shortly be performing emergency work on the network to address degradation on services in your area. This work will result in a temporary service interruption. Due to local noise restrictions and safety requirements, the work will be performed during daylight hours.',
        maintenanceStartAt: '2025-08-04T14:00:00Z',
        maintenanceEndAt: '2025-08-04T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01k0ezvjpayq5v1ts49ahjpbbe',
        provider: 'NBN',
        providerOutageId: 'CRQ000009081761',
        severity: 'Emergency',
        type: 'Scheduled Outage',
        description:
          'nbn will shortly be performing urgent work on the network in your area. You will experience a temporary service interruption during this activity.',
        maintenanceStartAt: '2025-07-18T14:00:00Z',
        maintenanceEndAt: '2025-07-18T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jzqv062qktqgzt2tqxfyzp5r',
        provider: 'NBN',
        providerOutageId: 'CRQ000009079470',
        severity: 'Emergency',
        type: 'Scheduled Outage',
        description:
          'nbn will shortly be performing urgent work on the network in your area. You will experience a temporary service interruption during this activity.',
        maintenanceStartAt: '2025-07-09T14:00:00Z',
        maintenanceEndAt: '2025-07-09T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jz4hx5vk73c03dpn297znx0j',
        provider: 'NBN',
        providerOutageId: 'INC000021166982',
        severity: 'Medium',
        type: 'Unscheduled Outage',
        description:
          'Total Impacted  service(s)  6  of which  is/are Priority Assist.          \nAVC400034575348 listed under CVC000000703695\n AVC400034575471 listed under CVC000000703695\n AVC400034690391 listed under CVC000000703695\n AVC400034692347 listed under CVC000000703695\n AVC400044902069 listed under CVC000000703695\n AVC400056349838 listed under CVC000000812118',
        maintenanceStartAt: '2025-07-02T02:49:02Z',
        maintenanceEndAt: '2025-07-02T06:40:14Z',
        status: 'closed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jz2crk1ghc58t3d4n6h795py',
        provider: 'NBN',
        providerOutageId: 'CRQ000009075069',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking a series of planned activities to enhance the network capacity in your area. During this upgrade period, you may experience multiple interruptions as we work on optimising the network hardware. For safety reasons, some of these activities must be conducted during daytime hours.',
        maintenanceStartAt: '2025-07-20T21:00:00Z',
        maintenanceEndAt: '2025-07-25T09:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jz0jq0yrc456fbf7a5k02431',
        provider: 'NBN',
        providerOutageId: 'CRQ000008955187',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn will soon be performing work on hardware and fibre in your area. This will cause a service interruption overnight where you will be temporarily unable to access the nbn network.',
        maintenanceStartAt: '2025-06-30T14:00:00Z',
        maintenanceEndAt: '2025-06-30T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jyzcvhtcz0nz9se82fg42k4f',
        provider: 'NBN',
        providerOutageId: 'CRQ000008973929',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking planned work to enable future expansion of the network. During this overnight activity, you will experience a short interruption as network hardware is upgraded.',
        maintenanceStartAt: '2025-07-16T14:00:00Z',
        maintenanceEndAt: '2025-07-16T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jyag0wax6e9jaqctbwqx2m5f',
        provider: 'NBN',
        providerOutageId: 'CRQ000008974549',
        severity: 'Expedited',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking a series of planned activities to upgrade the network in your area. During this upgrade period, you may experience multiple interruptions as we work on upgrading the network hardware. For safety reasons, these activities may be conducted during daytime hours.',
        maintenanceStartAt: '2025-06-23T21:00:00Z',
        maintenanceEndAt: '2025-06-24T05:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jy505vj3qq6e5q29rbfgh47e',
        provider: 'NBN',
        providerOutageId: 'CRQ000008930019',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking a series of planned activities to upgrade the network in your area. During this upgrade period, you may experience multiple interruptions as we work on upgrading the network hardware. For safety reasons, these activities may be conducted during daytime hours.',
        maintenanceStartAt: '2025-06-19T21:00:00Z',
        maintenanceEndAt: '2025-06-20T05:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jxkza5tgza4xzm699bz2h610',
        provider: 'NBN',
        providerOutageId: 'CRQ000008945111',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking planned work to enable future expansion of the network. During this overnight activity, you will experience a short interruption as network hardware is upgraded.',
        maintenanceStartAt: '2025-06-25T14:00:00Z',
        maintenanceEndAt: '2025-06-25T20:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jwwb658ecvf41m79bjxbcq18',
        provider: 'NBN',
        providerOutageId: 'CRQ000008928302',
        severity: 'Normal',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking a series of planned activities to upgrade the network in your area. During this upgrade period, you may experience multiple interruptions as we work on upgrading the network hardware. For safety reasons, these activities may be conducted during daytime hours.',
        maintenanceStartAt: '2025-06-23T21:00:00Z',
        maintenanceEndAt: '2025-06-24T05:00:00Z',
        status: 'completed',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jvthv578cmtg3nb8trhc663v',
        provider: 'NBN',
        providerOutageId: 'CRQ000008874385',
        severity: 'Expedited',
        type: 'Scheduled Outage',
        description:
          'nbn is undertaking planned work to enable future expansion of the network. During this overnight activity, you will experience a short interruption as network hardware is upgraded.',
        maintenanceStartAt: '2025-06-03T14:00:00Z',
        maintenanceEndAt: '2025-06-03T20:00:00Z',
        status: 'cancelled',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jt7mjtc156cxd7cta0ttvc2a',
        provider: 'NBN',
        providerOutageId: 'CRQ000008712824',
        severity: 'Expedited',
        type: 'Scheduled Outage',
        description:
          'nbn will soon be performing work on hardware and fibre in your area. This will cause a service interruption overnight where you will be temporarily unable to access the nbn network.',
        maintenanceStartAt: '2025-05-05T14:01:00Z',
        maintenanceEndAt: '2025-05-05T20:00:00Z',
        status: 'cancelled',
        priority: null,
        startTime: null,
        endTime: null,
      },
      {
        id: '01jsg498jkdmyvfzce3a5hkrqh',
        provider: 'NBN',
        providerOutageId: 'INC000020681247',
        severity: 'Medium',
        type: 'Unscheduled Outage',
        description:
          'Total Impacted service(s)-3\nAVC400039783201 listed under CVC000000778914\nAVC400052634904 listed under CVC000000789700\nAVC400051927112 listed under CVC000000789020',
        maintenanceStartAt: '2025-03-14T03:47:24Z',
        maintenanceEndAt: '2025-04-23T01:16:10Z',
        status: 'closed',
        priority: null,
        startTime: null,
        endTime: null,
      },
    ],
    links: {
      url: null,
      label: null,
      active: false,
      first:
        'http://group-api.superloop.ltd/api/v1/outage-management/outages?page=1',
      last: 'http://group-api.superloop.ltd/api/v1/outage-management/outages?page=1',
      prev: null,
      next: null,
    },
    meta: {
      current_page: null,
      from: null,
      last_page: null,
      links: null,
      path: 'http://group-api.superloop.ltd/api/v1/outage-management/outages',
      per_page: 15,
      to: null,
      total: null,
    },
  }
